import { Button, Divider } from '@mui/material';
import DataLossWarningModal from 'components/DataLossWarningModal';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { Row } from 'further-ui/components/Layout';
import { useDisclosure } from 'further-ui/hooks';
import React, { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import HoldingClassRightsForm from 'routes/LpPages/Common/HoldingClass/HoldingClassRightsForm';
import HoldingClassSelection from './HoldingClassSelection';

interface HoldingClassDetailsFormProps {
  index: number;
  field: Record<string, any>;
  holdingClassOptions: Array<{
    id: string;
    title: string;
    currency: CurrencyCode;
  }>;

  onRemove: () => void;

  isFirst: boolean;
  resetHoldingClassDropdown: (index: number) => void;
  isNewHoldingClass: boolean;
  isHoldingClassSelectDisabled: boolean;
  vehicleCurrencyCode: CurrencyCode;
  assetBaseCurrency?: CurrencyCode;
}

const HoldingClassDetailsForm: FC<HoldingClassDetailsFormProps> = ({
  index,
  field,
  holdingClassOptions,

  onRemove,

  isFirst,
  resetHoldingClassDropdown,
  isNewHoldingClass,
  isHoldingClassSelectDisabled,
  vehicleCurrencyCode,
  assetBaseCurrency,
}) => {
  const removeDisclosure = useDisclosure();
  const { control } = useFormContext();

  return (
    <React.Fragment key={field.id}>
      {index > 0 && <Divider />}
      <HoldingClassSelection
        index={index}
        holdingClassOptions={holdingClassOptions}
        resetHoldingClassDropdown={() => resetHoldingClassDropdown(index)}
        isHoldingClassSelectDisabled={isHoldingClassSelectDisabled}
      />

      {isNewHoldingClass && (
        <HoldingClassRightsForm
          index={index}
          formName="holdingClasses"
          control={control}
          disableCurrency={true}
          assetBaseCurrency={assetBaseCurrency}
          vehicleCurrencyCode={vehicleCurrencyCode}
        />
      )}

      {!isFirst && (
        <Row justify="flex-end">
          <Button
            variant="text"
            onClick={() => {
              if (isNewHoldingClass) {
                removeDisclosure.onOpen();
              } else {
                onRemove();
              }
            }}
            color="error"
            size="small"
          >
            Remove additional holding class
          </Button>
        </Row>
      )}

      <DataLossWarningModal
        message="If you remove this holding class, all class information you have input will be lost. Do you wish to continue?"
        disclosure={removeDisclosure}
        onConfirm={onRemove}
        onCancel={removeDisclosure.onClose}
      />
    </React.Fragment>
  );
};

export default HoldingClassDetailsForm;
